import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarWideLeftArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSidebarWideLeftArrow"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H7.5V4H22V20ZM16.3107 9.75L15.25 8.68934L11.9393 12L15.25 15.3107L16.3107 14.25L14.0607 12L16.3107 9.75Z" fill="currentColor"/><Path d="M2 4H6V20H2V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarWideLeftArrow;
